import React, { Component } from "react"
// eslint-disable-line no-unused-vars

export default class Width extends Component {
  state = {}

  render() {
    return <div className={`${this.props.modifier}`}>{this.props.children}</div>
  }
}
